import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { EmailTemplatesEventInvitation } from '@recruitee/http/types';
import { ID } from '@recruitee/ngrx';

import { EventInvitationCollectionPayload } from '../types';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesEventInvitationHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadCollection(
    payload?: EventInvitationCollectionPayload,
  ): Observable<EmailTemplatesEventInvitation[]> {
    return this.httpApi
      .get(`/event_invitation_templates`, payload)
      .pipe(map(data => data.eventInvitationTemplates));
  }

  public create(
    data: Partial<EmailTemplatesEventInvitation>,
  ): Observable<EmailTemplatesEventInvitation> {
    const { title, bodyHtml, subject } = data;
    const eventInvitationTemplate = {
      title,
      ...(bodyHtml ? { bodyHtml: bodyHtml } : {}),
      ...(subject ? { subject: subject } : {}),
    };

    return this.httpApi
      .post(`/event_invitation_templates`, null, { eventInvitationTemplate })
      .pipe(map(data => data.eventInvitationTemplate));
  }

  public duplicate({ id }: { id: number }): Observable<EmailTemplatesEventInvitation> {
    return this.httpApi
      .post(`/event_invitation_templates/${id}`, null, null)
      .pipe(map(data => data.eventInvitationTemplate));
  }

  public update(
    data: Partial<EmailTemplatesEventInvitation>,
  ): Observable<EmailTemplatesEventInvitation> {
    const { id, ...eventInvitationTemplate } = data;
    return this.httpApi
      .patch(`/event_invitation_templates/${id}`, null, {
        eventInvitationTemplate,
      })
      .pipe(map(data => data.eventInvitationTemplate));
  }

  public delete(id: ID): Observable<EmailTemplatesEventInvitation> {
    return this.httpApi
      .delete(`/event_invitation_templates/${id}`, null)
      .pipe(map(data => data.eventInvitationTemplate));
  }

  public updatePositions(ids: number[]): Observable<EmailTemplatesEventInvitation[]> {
    return this.httpApi
      .patch(`/event_invitation_templates/update_positions`, null, {
        eventInvitationTemplates: ids,
      })
      .pipe(map(data => data.eventInvitationTemplates));
  }
}
